import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { getDefaultComponentData } from '../../types';
export default function galleryComponentWrapper(ExternalComponent) {
    return withDimensions(class GalleryComponentWrapper extends React.Component {
        render() {
            const { componentData: { data, config, styles, galleryLayout, settings }, width } = this.props;
            var _styles_galleryLayout, _ref;
            // Some versions got layout mixed up but we have to support all options
            // now because old data is cached... styles should contain all the settings.
            const layout = (_ref = (_styles_galleryLayout = styles === null || styles === void 0 ? void 0 : styles.galleryLayout) !== null && _styles_galleryLayout !== void 0 ? _styles_galleryLayout : galleryLayout) !== null && _ref !== void 0 ? _ref : settings === null || settings === void 0 ? void 0 : settings.defaultLayout;
            return /*#__PURE__*/ React.createElement(ExternalComponent, {
                config: config,
                data: data,
                layout: layout,
                width: width,
                settings: settings,
                layoutStyles: styles
            });
        }
        constructor(props){
            super(props);
            _define_property(this, "blockKey", void 0);
            _define_property(this, "stateFromProps", (props)=>{
                const items = props.componentData.items || [];
                const styles = _object_spread({}, getDefaultComponentData(), props.componentData.styles || {});
                const state = {
                    items,
                    styles
                };
                return state;
            });
            _define_property(this, "handleFilesAdded", (data)=>{
                // when updating componentData on an async method like this one,
                // we need to use a sync method to change the EditorState.
                // The broadcast is good if the toolbar is displaying some status or images
                this.props.componentData.data = data.data || data;
                this.props.componentData.styles = this.state.styles;
                const { setData } = this.props.blockProps;
                setData(this.props.componentData);
                if (this.props.store) {
                    this.props.store.set('componentData', {
                        data: data.data || data,
                        styles: this.state.styles,
                        config: this.props.componentData.config,
                        settings: this.props.settings,
                        items: []
                    });
                }
            });
            this.state = this.stateFromProps(props);
            const { block, commonPubsub, store } = this.props;
            this.blockKey = block === null || block === void 0 ? void 0 : block.getKey();
            commonPubsub && commonPubsub.setBlockHandler('galleryHandleFilesAdded', this.blockKey, this.handleFilesAdded.bind(this));
            if (store) {
                store.setBlockHandler('handleFilesAdded', this.blockKey, this.handleFilesAdded.bind(this));
            }
        }
    });
}
